var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"round-xl pa-4 mb-3",attrs:{"outlined":""}},[_c('redeem-offer-item-property',{attrs:{"item":_vm.offer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }